export enum OrderViewerOptions {
	None = 0,
	Enrichment = 1 << 0,
	RequestNewVersion = 1 << 1,
	AddToSharedLib = 1 << 2,
	ShowReceipt = 1 << 3,
	UseAltmetric = 1 << 4
}

export enum OrderDocumentOptions {
	None = 0,
	DrmProtected = 1 << 0,
	LinkOut = 1 << 1
}

export enum OrderViewerTab {
	Default = 0,
	OrderDetails = 1,
	CitationDetails = 2
}

export enum ViewInLibraryStatus {
	None = 0,
	Enabled = 1,
	NeedPolling = 2,
	Disabled = 3
}

export enum OrderViewerError {
	None = 0,
	NotFound = 1
}
